import { render, staticRenderFns } from "./RiskLevelBadge.vue?vue&type=template&id=0b65e808&scoped=true&"
import script from "./RiskLevelBadge.vue?vue&type=script&lang=js&"
export * from "./RiskLevelBadge.vue?vue&type=script&lang=js&"
import style0 from "./RiskLevelBadge.vue?vue&type=style&index=0&id=0b65e808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b65e808",
  null
  
)

export default component.exports